export default function _globalAlert() {
    /**
     * Warning alert wrapper selector
     * @const {string}
     */
    const GLOBAL_WARNING_ALERT_SELECTOR = '.global-alert.warning';

    /**
     * Warning alert wrapper selector
     * @const {string}
     */
    const GLOBAL_WARNING_ALERT_CONTENTS =
        '.global-alert.warning .global-alert__contents';

    /**
     * Warning alert close control
     * @const {string}
     */
    const GLOBAL_WARNING_ALERT_CLOSE = '.global-alert__button';

    /**
     * Warning alert close control
     * @const {string}
     */
    const warningAlert = document.querySelector(GLOBAL_WARNING_ALERT_SELECTOR);

    /**
     * Warning alert close control
     * @const {string}
     */
    const warningAlertContents = document.querySelector(
        GLOBAL_WARNING_ALERT_CONTENTS
    );

    // Add event listener to the warning alert X button
    function warningAlertCloseListener(selector) {
        // On click of the close [X] button, scroll banner out up to expose more of the main content
        selector.addEventListener('click', () => {
            warningAlert.className += ' closed';
            sessionStorage.setItem('warningClosed', true);
        });
    }

    // When the page changes size e.g. mobile phone turned sideways, redo the maxHeight of the warning box
    function reHeight() {
        warningAlert.style.maxHeight = `${warningAlertContents.offsetHeight}px`;
    }

    // If a warning alert exists
    if (warningAlert) {
        // If the page resizes, run function reHeight()
        window.addEventListener('resize', reHeight);
        if (sessionStorage.getItem('warningClosed') === null) {
            warningAlert.classList.remove('closed');
            warningAlert.style.maxHeight = `${warningAlertContents.offsetHeight}px`;
        }
        warningAlertCloseListener(
            document.querySelector(GLOBAL_WARNING_ALERT_CLOSE)
        );
    }
}

_globalAlert();
